<div class="bg-white">
  <div class="container mx-auto">
    <div class="flex sm:items-center px-4 py-3">
      <div class="pr-2">
        <a class="text-gray-300" href="javascript:void(0);" (click)="back()">
          <i class="fa fa-angle-left font-bold text-3xl"></i>
        </a>
      </div>
      <div class="text-gray-300 font-medium flex-1 text-center text-sm sm:text-base">
        {{knowledgeBaseHeading }} <span class="text-danger text-xs">(AI in training: Cross-check answers with Knowledge Base)</span>
      </div>
      <div>
        <button (click)="clearAllThreads()" class="bg-primary font-semibold gap-1 items-center px-2 py-1.5 rounded-md shadow-sm text-white text-xs w-14">Clear</button>
      </div>
    </div>
  </div>
</div>
<div class="container mx-auto relative px-4 py-4 min-h-90-vh lg:min-h-70-vh xl:min-h-screen mb-18 max-w-5xl">
  <div class="mt-16 mb-20">
    @for (qa of questionAnswersList; track qa) {
      <div class="grid lg:grid-cols-1 gap-4 knowledge-base-items" >
        <div class="bg-white shadow-card p-2 sm:p-6 leading-5 sm:leading-6  mb-4">
          <h3 class="text-gray-600 leading-6 sm:text-lg mb-1">
            <p> {{ qa.question }}</p>
          </h3>
          <p class="text-base text-gray-700 font-normal linkColor " style="white-space: pre-line;" [innerHtml]="qa.answer"></p>
          @if (qa.streamingResponse) {
            <div class="flex items-left justify-left mb-2 relative">
              <img src="assets/typing-loading.gif" width="50px" height="50px"/>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <div class="bg-body bottom-0  mb-6 py-8  search-bar z-1000 " id="bottomFixedStop" style=" transform:translateX(-50%); position: fixed; left:50%; margin:0 auto; max-width: 968px;">
    @if (isProcessing) {
      <div class="flex items-center justify-center mb-2 relative">
        <i class="fa fa-spinner fa-spin fa-2x text-primary" aria-hidden="true"></i>
      </div>
    }
    <div class="flex relative">
      <input type="text" (keyup.enter)="handler($event)" [(ngModel)]="inputContent" placeholder="Type Something" class=" mb-4 md:mb-6 border border-gray-light px-4 py-2 pl-8 md:pl-4 text-sm text-gray-300 placeholder-gray-light w-full rounded-md focus:outline-none focus:border-primary focus:shadow-card"/>
      @if (!isProcessing) {
        <button [disabled]="isProcessing" (click)="handler($event)" class="absolute bg-primary font-semibold gap-1 items-center mr-1.5 mt-1 px-2 py-1.5 right-0 rounded-md shadow-sm text-white text-xs top-0 w-16">Ask</button>
      }
      @if (isProcessing) {
        <button  [disabled]="isProcessing" class="absolute bg-primary font-semibold gap-1 items-center mr-1.5 mt-1 px-2 py-1.5 right-0 rounded-md shadow-sm text-white text-xs top-0 w-16">Ask</button>
      }
    </div>
  </div>
</div>
<div id="bottomFixedStopArea" class="pt-4" style="height: 5px;padding-top: 15px;"></div>
